<template>
  <div class="mockdetails">
    <div class="inner" v-loading="answallLoading">
      <div class="mockcenter">
        <div class="mock_left">
          <!-- 考试标题和信息 -->
          <div class="mock_info">
            <p class="mockpaper_tit">{{ paperData.title }}</p>
            <div class="paper_info">
              <p>考试题数：{{ allItem.length }}道</p>
              <p>考试时间：{{ totalexam }}分钟</p>
              <p>满分：{{ paperData.totalScore }}分</p>
            </div>
          </div>
          <div class="paper_content" v-if="handpaper == null">
            <p class="qutype" v-if="quData.quType == 1">
              一、单选题
              <span class="qumiaoshu">(共{{ paperData.radioList.length }}题)</span>
            </p>
            <p class="qutype" v-if="quData.quType == 2">
              二、多选题
              <span class="qumiaoshu">(共{{ paperData.multiList.length }}题)</span>
            </p>
            <p class="qutype" v-if="quData.quType == 3">
              三、判断题
              <span class="qumiaoshu">(共{{ paperData.judgeList.length }}题)</span>
            </p>

            <p class="qutit" v-if="quData.content">
              <span class="qutpe_span">{{
                quData.quType == 1
                  ? "单选题"
                  : quData.quType == 2
                  ? "多选题"
                  : quData.quType == 3
                  ? "判断题"
                  : ""
              }}</span>
              {{ quData.sort + 1 }}.{{ quData.content }}
              <span class="qumiaoshu">({{ quData.score }}分)</span>
            </p>

            <div
              v-if="quData.quType === 1 || quData.quType === 3"
              style="margin-top: 10px"
            >
              <el-radio-group v-model="radioValue" @change="handSave(quData)">
                <el-radio
                  v-for="item in quData.answerList"
                  :key="item.id"
                  :label="item.id"
                  style="margin-top: 15px"
                  >{{ item.abc }}. {{ item.content }}
                  <div v-if="item.image" style="clear: both"
                /></el-radio>
              </el-radio-group>
            </div>
            <div v-if="quData.quType === 2" style="margin-top: 10px">
              <el-checkbox-group v-model="multiValue" @change="handSave(quData)">
                <el-checkbox
                  v-for="item in quData.answerList"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.abc }}. {{ item.content }}
                  <div v-if="item.image" style="clear: both"
                /></el-checkbox>
              </el-checkbox-group>
            </div>
            <div style="margin-top: 20px">
              <el-button
                v-if="showPrevious"
                :loading="quloading"
                icon="el-icon-back"
                @click="handPrevious()"
              >
                上一题
              </el-button>

              <el-button
                v-if="showNext"
                type="warning"
                style="background: #045923; border: 1px solid #045923"
                :loading="quloading"
                icon="el-icon-right"
                @click="handNext()"
              >
                下一题
              </el-button>
            </div>
          </div>
          <!-- 交卷后的成绩 -->
          <div class="paper_content" v-else>
            <p class="overexam">完成考试</p>
            <p class="overexam_score">
              <span class="exam_scoretxt">{{ handpaper.userScore || 0 }}</span
              >分
            </p>
            <div class="exam_Statlist">
              <div class="exam_statitem">
                <p class="examItem_p1">正确率</p>
                <p class="examItem_p2">{{ handpaper.accuracy || 0 }}%</p>
              </div>
              <div class="exam_xian"></div>
              <div class="exam_statitem">
                <p class="examItem_p1">考试用时</p>
                <p class="examItem_p2">{{ handpaper.userTime || 0 }}</p>
              </div>
            </div>
            <p class="exam_message">个人中心-我的考试，可以查看考试详情复习考题</p>
            <div class="exam_butflex">
              <el-button class="exam_fanh" @click="backrouter"> 返回 </el-button>
              <el-button
                class="exam_fanh"
                @click="myrouter"
                style="background: #045923; border: 1px solid #045923"
                type="primary"
              >
                个人中心
              </el-button>
            </div>
          </div>
        </div>
        <div class="mock_rig">
          <div class="examtime">
            <img class="examTimeimg" src="../../assets/images/Examtime.png" alt="" />
            <span class="time_txt">{{ min }}分钟{{ sec }}秒</span>
          </div>
          <!-- 间隔槽 -->
          <div class="exam_ider"></div>
          <!-- 题目 -->
          <div class="exam_rigbotm">
            <div
              v-if="paperData.radioList !== undefined && paperData.radioList.length > 0"
            >
              <p class="card-title">单选题</p>

              <!-- <div class="eilog_tiAll">
                <span
                  v-for="(item, index) in paperData.radioList"
                  :key="index"
                  :class="cardItemClass(item.answered, item.quId)"
                  @click="handSave(item)"
                  >{{ item.sort + 1 }}</span
                >
              </div> -->
              <el-tag
                v-for="item in paperData.radioList"
                :key="item.id"
                style="cursor: pointer"
                :type="cardItemClass(item.answered, item.quId)"
                @click="handSave(item)"
              >
                {{ item.sort + 1 > 9 ? item.sort + 1 : "0" + (item.sort + 1) }}</el-tag
              >
            </div>
            <div
              v-if="paperData.multiList !== undefined && paperData.multiList.length > 0"
            >
              <p class="card-title">多选题</p>

              <el-tag
                v-for="item in paperData.multiList"
                :key="item.id"
                style="cursor: pointer"
                :type="cardItemClass(item.answered, item.quId)"
                @click="handSave(item)"
                >{{ item.sort + 1 }}</el-tag
              >
            </div>
            <div
              v-if="paperData.judgeList !== undefined && paperData.judgeList.length > 0"
            >
              <p class="card-title">判断题</p>

              <el-tag
                v-for="item in paperData.judgeList"
                :key="item.id"
                style="cursor: pointer"
                :type="cardItemClass(item.answered, item.quId)"
                @click="handSave(item)"
                >{{ item.sort + 1 }}</el-tag
              >
            </div>
            <div class="postexams">
              <el-button
                v-if="handpaper == null"
                style="width: 100%; background: #045923; border: 1px solid #045923"
                type="primary"
                icon="el-icon-plus"
                :loading="loading"
                @click="handHandExam()"
              >
                {{ handleText }}
              </el-button>
              <el-button
                v-else
                style="width: 100%; background: #045923; border: 1px solid #045923"
                type="primary"
                @click="backrouter"
              >
                返回首页
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  paperDetail,
  papercreate,
  quDetail,
  fillAnswer,
  handExam,
  paperResult,
} from "@/api/mockExamination";
import { Loading } from "element-ui";
export default {
  name: "mockdetails",
  data() {
    return {
      // 当前页
      thisPage: "",
      // 全屏/不全屏
      isFullscreen: false,
      showPrevious: false,
      showNext: true,
      loading: false,
      handleText: "交卷",
      pageLoading: false,
      // 试卷ID
      paperId: "",
      // 当前答题卡
      cardItem: {},
      allItem: [],
      // 当前题目内容
      quData: {
        answerList: [],
      },
      // 试卷信息
      paperData: {
        leftSeconds: 0,
        radioList: [],
        multiList: [],
        judgeList: [],
      },
      // 单选选定值
      radioValue: "",
      // 多选选定值
      multiValue: [],
      // 已答ID
      answeredIds: [],
      min: "00",
      sec: "00",
      examId: "",
      answallLoading: false,
      quloading: false,
      totalexam: 0, //考试总时长
      handpaper: null,
      countTime: null, //定时器
    };
  },
  created() {
    this.$store.commit("user/SET_TABINDEX", 1090);
  },
  mounted() {
    const id = this.$route.query.id;
    this.totalexam = this.$route.query.totalexam;
    if (typeof id !== "undefined" && !this.$route.query.examstate) {
      this.examId = id;
      this.createExam();
    }
  },
  destroyed() {
    clearTimeout(this.countTime);
    this.countTime = null;
  },
  methods: {
    goBack() {
      // console.log("点击了浏览器的返回按钮");
      history.pushState(null, null, document.URL);
    },

    // 倒计时
    countdown() {
      const leftSeconds = this.paperData.leftSeconds;
      // 强制交卷
      if (leftSeconds < 0) {
        this.doHandler();
        return;
      }

      // 时
      const min = parseInt(leftSeconds / 60);
      const sec = parseInt(leftSeconds % 60);

      this.min = min > 9 ? min : "0" + min;
      this.sec = sec > 9 ? sec : "0" + sec;
      const that = this;
      this.paperData.leftSeconds -= 1;
      clearTimeout(this.countTime);
      this.countTime = setTimeout(function () {
        that.countdown();
      }, 1000);
      console.log("定时器");
    },

    // 答题卡样式
    cardItemClass(answered, quId) {
      if (quId === this.cardItem.quId) {
        return "warning";
        // return "activSpan";
      }

      if (answered) {
        return "success";
        // return "activSpan";
      }

      if (!answered) {
        return "info";
        // return " ";
      }
    },

    /**
     * 统计有多少题没答的
     * @returns {number}
     */
    countNotAnswered() {
      let notAnswered = 0;

      this.paperData.radioList.forEach(function (item) {
        if (!item.answered) {
          notAnswered += 1;
        }
      });

      this.paperData.multiList.forEach(function (item) {
        if (!item.answered) {
          notAnswered += 1;
        }
      });

      this.paperData.judgeList.forEach(function (item) {
        if (!item.answered) {
          notAnswered += 1;
        }
      });

      return notAnswered;
    },

    /**
     * 下一题
     */
    handNext() {
      this.quloading = true;
      const index = this.cardItem.sort + 1;
      this.handSave(this.allItem[index]);
    },

    /**
     * 上一题
     */
    handPrevious() {
      this.quloading = true;
      const index = this.cardItem.sort - 1;
      this.handSave(this.allItem[index]);
    },

    doHandler() {
      this.handleText = "正在交卷，请等待...";
      this.loading = true;
      const params = { id: this.paperId };
      handExam(params).then(() => {
        this.$message({
          message: "试卷提交成功",
          type: "success",
        });
        this.loading = false;
        clearTimeout(this.countTime);
        this.countTime = null;
        //查询结果
        this.Resultpaper();
        // this.$router.push({ name: "ShowExam", params: { id: this.paperId } });
      });
    },
    // 交卷操作
    handHandExam() {
      const that = this;

      // 交卷保存答案
      this.handSave(this.cardItem, function () {
        const notAnswered = that.countNotAnswered();

        let msg = "确认要交卷吗？";

        if (notAnswered > 0) {
          msg = "您还有" + notAnswered + "题未作答，确认要交卷吗?";
        }

        that
          .$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            that.doHandler();
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "交卷已取消，您可以继续作答！",
            });
          });
      });
    },

    // 保存答案
    handSave(item, callback) {
      if (item.id === this.allItem[0].id) {
        this.showPrevious = false;
      } else {
        this.showPrevious = true;
      }

      // 最后一个索引
      const last = this.allItem.length - 1;

      if (item.id === this.allItem[last].id) {
        this.showNext = false;
      } else {
        this.showNext = true;
      }

      const answers = this.multiValue;
      if (this.radioValue !== "") {
        answers.push(this.radioValue);
      }

      const params = {
        paperId: this.paperId,
        quId: this.cardItem.quId,
        answers: answers,
        answer: "",
        surplusMin: this.min,
        surplusSecond: this.sec,
      };
      fillAnswer(params).then(() => {
        // 必须选择一个值
        if (answers.length > 0) {
          // 加入已答列表
          this.cardItem.answered = true;
        }

        // 最后一个动作，交卷
        if (callback) {
          callback();
        }

        // 查找详情
        this.fetchQuData(item);
      });
    },
    // 题目详情
    fetchQuData(item) {
      // 打开
      // const loading = Loading.service({
      //   text: "拼命加载中",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });

      // 获得详情
      this.cardItem = item;
      // 查找下个详情
      const params = { paperId: this.paperId, quId: item.quId };
      quDetail(params).then((response) => {
        this.quData = response.data;
        this.radioValue = "";
        this.multiValue = [];
        // 填充该题目的答案
        this.quData.answerList.forEach((item) => {
          if ((this.quData.quType === 1 || this.quData.quType === 3) && item.checked) {
            this.radioValue = item.id;
          }

          if (this.quData.quType === 2 && item.checked) {
            this.multiValue.push(item.id);
          }
        });

        // 关闭详情
        // loading.close();
        this.quloading = false;
      });
    },
    // 2.试卷详情
    fetchData(id) {
      const params = { id: id };
      paperDetail(params).then((response) => {
        // 试卷内容
        this.paperData = response.data;
        // 获得第一题内容
        if (this.paperData.radioList.length > 0) {
          this.cardItem = this.paperData.radioList[0];
        } else if (this.paperData.multiList.length > 0) {
          this.cardItem = this.paperData.multiList[0];
        } else if (this.paperData.judgeList.length > 0) {
          this.cardItem = this.paperData.judgeList[0];
        }

        const that = this;

        this.paperData.radioList.forEach(function (item) {
          that.allItem.push(item);
        });

        this.paperData.multiList.forEach(function (item) {
          that.allItem.push(item);
        });

        this.paperData.judgeList.forEach(function (item) {
          that.allItem.push(item);
        });
        // 当前选定
        this.fetchQuData(this.cardItem);
        // 倒计时
        this.countdown();
        this.answallLoading = false;
      });
    },
    //1.创建考试
    createExam() {
      this.answallLoading = true;
      let data = { examId: this.examId };
      papercreate(data).then((res) => {
        this.paperId = res.data.id;
        this.fetchData(res.data.id);
      });
    },
    //查询结果
    Resultpaper() {
      paperResult({ id: this.paperId }).then((res) => {
        this.handpaper = res.data;
      });
    },
    //返回列表
    backrouter() {
      this.$router.push({ path: "/mockExamination" });
    },
    //个人中心
    myrouter() {
      this.$router.push({ path: "/personal-center" });
    },
  },
};
</script>
<style scoped>
.mockdetails {
  width: 100%;
  background: #f5f5f5;
}
.mockcenter {
  padding: 20px 0;
  min-height: 600px;
  overflow: hidden;
}
.mock_left {
  width: 67%;
  min-height: 600px;
  background-color: #ffffff;
  float: left;
  padding: 24px 0;
}
.mock_info {
  border-bottom: 1px solid #f5f5f5;
  overflow: hidden;
}
.paper_content {
  padding: 26px 50px;
}
.qutit {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  padding: 10px 0;
  line-height: 1.6;
}
.qutype {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.qutpe_span {
  display: inline-block;
  padding: 2px 6px;
  background: #045923;
  border-radius: 4px;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
}
.qumiaoshu {
  color: #b8b8b8;
  font-size: 14px;
  font-weight: 400;
}

.mockpaper_tit {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  text-align: center;
}
.paper_info {
  width: 400px;
  margin: 10px auto;
  display: flex;
  justify-content: space-around;
  color: #555555;
  font-size: 14px;
  font-weight: 500;
}
.mock_rig {
  width: 30%;
  min-height: 600px;
  background-color: #ffffff;
  float: right;
  position: relative;
}

.el-checkbox-group label,
.el-radio-group label {
  width: 100%;
}

.card-title {
  line-height: 35px;
  font-size: 16px;
  color: #333333;
}
.card-line {
  padding-left: 10px;
}
.card-line span {
  cursor: pointer;
  margin: 2px;
}

/deep/ .el-radio,
.el-checkbox {
  padding: 9px 20px 9px 10px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  margin-bottom: 10px;
}

.is-checked {
  border: #1d4434 1px solid;
}
.is-checked >>> span {
  color: #1d4434 !important;
}
.el-radio img,
.el-checkbox img {
  max-width: 200px;
  max-height: 200px;
  border: #dcdfe6 1px dotted;
}

/deep/ .el-checkbox__inner {
  display: none;
}

/deep/ .el-radio__inner {
  display: none;
}

/deep/ .el-checkbox__label {
  line-height: 30px;
  font-size: 16px;
  color: #333333;
}

/deep/ .el-radio__label {
  line-height: 30px;
}

/* 考试时间 */
.examtime {
  width: 100%;
  height: 55px;
  line-height: 55px;
  position: relative;
  text-align: center;
}
.examTimeimg {
  display: inline-block;
  width: 31px;
  height: 34px;
  margin-bottom: 10px;
  vertical-align: middle;
}
.time_txt {
  font-size: 24px;
  font-weight: 500;
  color: #555555;
  margin-left: 11px;
}
.exam_ider {
  width: 100%;
  height: 10px;
  background: #f5f5f5;
}
.exam_rigbotm {
  margin: 5px 14px;
}
.tagrig {
  margin: 10px 0 0 0;
}
.eilog_tiAll {
  width: 100%;
  border-radius: 5px;
}
.eilog_tiAll > span {
  display: inline-block;
  width: 49.5px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid #999999;
  cursor: pointer;
  user-select: none;
  margin: 0 -1px -1px 0;
}
.eilog_tiAll > span:hover {
  color: #409eff;
}
.activSpan {
  background-color: #4640b8;
  color: #ffffff;
}
/* 交卷按钮 */
.postexams {
  width: 90%;
  position: absolute;
  bottom: 20px;
  left: 14px;
}
/* 完成考试后的数据 */
.overexam {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  text-align: center;
}
.overexam_score {
  font-size: 16px;
  color: #B18227;
  text-align: center;
  margin: 30px 0;
}
.exam_scoretxt {
  font-size: 60px;
}
.exam_Statlist {
  width: 400px;
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
}
.exam_statitem {
  text-align: center;
}
.exam_xian {
  width: 2px;
  height: 50px;
  background-color: #f5f5f5;
}
.exam_message {
  font-size: 16px;
  font-weight: bold;
  color: #999999;
  text-align: center;
  margin-top: 50px;
  letter-spacing: 1px;
}
.examItem_p1 {
  font-size: 14px;
  font-weight: bold;
  color: #555555;
}
.examItem_p2 {
  font-size: 16px;
  font-weight: bold;
  color: #B18227;
  margin-top: 11px;
}
.exam_butflex {
  display: flex;
  justify-content: space-around;
  margin-top: 70px;
}
.exam_fanh {
  width: 262px;
  height: 42px;
  border-radius: 4px;
}
</style>
